module.exports = __webpack_public_path__ + "static/img/community.6f0695a5.svg";